import { render } from "./HistoricoVisitasView.vue?vue&type=template&id=37d8ece5&scoped=true"
import script from "./HistoricoVisitasView.vue?vue&type=script&lang=js"
export * from "./HistoricoVisitasView.vue?vue&type=script&lang=js"

import "./HistoricoVisitasView.vue?vue&type=style&index=0&id=37d8ece5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37d8ece5"]])

export default __exports__